import React from 'react';

const UploadedFile = (props) => {
  const { name, size, remove } = props;
  let sizeInMb = undefined;
  if (size) {
    try {
      sizeInMb = (size / 1000000).toFixed(2);
    } catch (e) {

    }
  }
  return (
    <div
      style={{
        flexDirection: 'row',
        borderBottomWidth: 1,
      }}
    >
      <a
        style={{
          cursor: 'pointer',
          position: 'absolute',
          right: 0,
          color: 'red'
        }}
        onClick={() => {
          remove();
        }}
      >
        X
      </a>
      {sizeInMb ? <span
        style={{
          alignSelf: 'center',
          width: 20,
          height: 20,
          background: 'white'
        }}
      >
        {name} {'(' + sizeInMb + 'MB)'}
      </span> : null
      }
    </div>
  );
};

export default UploadedFile;



// WEBPACK FOOTER //
// ./src/components/Products/uploadedFile.js